import { DataRegion, DataRegionLabel } from 'types/models';

export const DataRegionLabelMap: {
  label: DataRegionLabel;
  value: DataRegion;
}[] = [
  { value: 'ap-southeast-2', label: 'Australia' },
  {
    value: 'ca-central-1',
    label: 'Canada',
  },
  { value: 'eu-west-2', label: 'United Kingdom' },
  { value: 'us-east-1', label: 'USA' },
];
